module.exports = __webpack_public_path__ + "static/img/ry_6.f15471b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ry_6.jpg
// module id = l/aF
// module chunks = 0